import ResizableForm from "../../../../spine-cms-vue/src/components/mixins/ResizableForm";

Vue.asyncComponent('bp-blueprint-settings', {
    mixins: [ResizableForm],
    props: {
        dataProvider: {
            type: Object,
            required: true
        }
    },
    computed: {
        activeTab() {
            return this.$route.params.activeTab;
        },
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return 'editor-blueprint-settings-width';
        }
    },
    methods: {
        setActiveTab(activeTab) {
            this.$router.push({
                name: 'blueprint-settings',
                query: this.$route.query,
                params: { activeTab: activeTab }
            });
        },
        /**
         * Close the stacked window by going back
         */
        close() {
            this.$router.push({name: 'blueprint',params:{blueprintId: this.$route.params.blueprintId}, query: this.$route.query});
        },
    }

}, 'blueprints/settings/bp-blueprint-settings.html');